import styles from './loader.module.scss'
import { cn } from 'utils/helpers'
import useAppState from 'utils/state'

export default function Loader() {
    const { loader } = useAppState()

    return <div className={cn(styles.container, loader && styles.show)} />
}
